'use client';
import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { theme } from '@/components/features/theme/theme';
import { CURSOR_TEXT, DispatchCursor } from 'haspr-cursor';

const Button = ({
					onSubmit,
					text,
					src, submit,
					img,
					hoverImg,
					fontSize,
					fontWeight,
					color,
					letterSpacing,
					lineHeight,
					margin,
					background,
					width,
					height,
					hoverBackground,
					target,
					hoverColor,
					icon,
					marginSm,
					onClick,
					className,
					pathColor, pathHoverColor, goBack
				}) => {
	//` The Cursor Action Dispatcher initialized
	const dispatch = DispatchCursor()
	const contStyle = {
		placeItems: 'center',
		cursor: 'pointer',
	}
	return (
		<StyledBtn style={contStyle} onMouseEnter={() => CURSOR_TEXT(dispatch, text)} onMouseLeave={() => CURSOR_TEXT(dispatch, 'END')} onClick={onClick} className={`${className ? className : null} dc-btn `}
				   fontSize={fontSize}
				   fontWeight={fontWeight}
				   pathHoverColor={pathHoverColor}
				   color={color}
				   background={background}
				   lineHeight={lineHeight}
				   letterSpacing={letterSpacing}
				   margin={margin}
				   img={img}
				   width={width}
				   hoverImg={hoverImg}
				   hoverBackground={hoverBackground}
				   height={height}
				   target={target}
				   hoverColor={hoverColor}
				   onSubmit={onSubmit}
				   icon={icon}
				   marginSm={marginSm}
				   submit={submit}
		>
			{
				submit ?
					<a>
						<span>{text}</span>
					</a> :
					<Link href={src || '/'}>


						{

							goBack ?
								<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
									<circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0)" fill="#152637" />
									<circle className={'hover_circle'} cx="20" cy="20" r="0" fill={hoverBackground ? hoverBackground : '#ED2024'} />
									<path d="M26 19C26.5523 19 27 19.4477 27 20C27 20.5523 26.5523 21 26 21V19ZM13.2929 20.7071C12.9024 20.3166 12.9024 19.6834 13.2929 19.2929L19.6569 12.9289C20.0474 12.5384 20.6805 12.5384 21.0711 12.9289C21.4616 13.3195 21.4616 13.9526 21.0711 14.3431L15.4142 20L21.0711 25.6569C21.4616 26.0474 21.4616 26.6805 21.0711 27.0711C20.6805 27.4616 20.0474 27.4616 19.6569 27.0711L13.2929 20.7071ZM26 21H14V19H26V21Z" fill="#EFEFEF" />
								</svg>

								:
								<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
									<circle cx="20" cy="20" r="20" fill={background ? background : 'white'} />
									<circle className={'hover_circle'} cx="20" cy="20" r="0" fill={hoverBackground ? hoverBackground : '#ED2024'} />
									<path d="M14 19C13.4477 19 13 19.4477 13 20C13 20.5523 13.4477 21 14 21V19ZM26.7071 20.7071C27.0976 20.3166 27.0976 19.6834 26.7071 19.2929L20.3431 12.9289C19.9526 12.5384 19.3195 12.5384 18.9289 12.9289C18.5384 13.3195 18.5384 13.9526 18.9289 14.3431L24.5858 20L18.9289 25.6569C18.5384 26.0474 18.5384 26.6805 18.9289 27.0711C19.3195 27.4616 19.9526 27.4616 20.3431 27.0711L26.7071 20.7071ZM14 21H26V19H14V21Z" fill={pathColor ? pathColor : '#152637'} />
								</svg>

						}
						<span>{text}</span>
					</Link>

			}

		</StyledBtn>
	);
};

const StyledBtn = styled.div`
    &.dc-btn {
        margin: ${props => props.margin || '0'};
        width: ${props => props.width || 'fit-content'};
        height: ${props => props.height || 'auto'};
        cursor: pointer;
        transition: ${theme.transition};

        a {
            display: inline-flex;
            align-items: center;
            gap: 12px;
            width: fit-content;
            height: auto;
            justify-content: center;
            font-size: ${props => props.fontSize || '1rem'};
            letter-spacing: ${props => props.letterSpacing || '0'};
            font-weight: ${props => props.fontWeight || theme.fontWeights.medium};
            margin: 0;
            line-height: ${props => props.lineHeight || '1.5rem'};
            position: relative;
            overflow: hidden;
            box-sizing: border-box;
            color: ${props => props.color || theme.colors.white};
            z-index: 1;
            transition: ${theme.transition};


            svg {
                circle, path {
                    transition: ${theme.transition};

                }
            }

            span {
                z-index: 99;
                transition: ${theme.transition};

            }

            &:hover {
                svg {
                    overflow: hidden;

                    .hover_circle {
                        r: 20px;
                    }

                    path {
                        fill: ${props => props.pathHoverColor || theme.colors.white};
                        transform: translateX(2px);
                    }
                }
                span {
                    color: ${props => props.hoverColor || theme.colors.hover};
                }

            }

            &:focus {
                color: ${props => props.color || '#282d31'};
            }
        }

        @media (max-width: 600px) {
            ${p => p.marginSm ? `margin:${p.marginSm}` : ''}
        }
    }




`;


export default Button;